<style>
	.white {
		color: #fff;
	}
	.centered {
		text-align: center;
	}
</style>
<script>
  export let color = 'white';
  export let centered = false;
</script>

<p class:white={color === 'white'} class:centered={centered}><slot /></p>
